import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import LegacyFormHelper from "@Scripts/Infrastructure/LegacyFormHelper";

@Component
export default class YESMarineRegistration extends Vue {
    public productRegistration: any = { taxCode: null };
    public isProductRegistrationValidated: boolean = false;

    public isRegistrationFormShown: boolean = false;

    public profileInfo: any = {};
    public profileRegistration: any = { birthDate: null };

    public taxCountries: any[] = [];
    public countries: any[] = [];
    public regions: any[] = [];
    public provinces: any[] = [];
    public addressTypes: any[] = [];
    public privacyPolicy: string = null;
    public isPrivacyPolicyShown: boolean = false;

    public locations: any[] = [];
    public locationSearchText: string = null;

    public validationErrors: any[] = [];
    public isSuccess: boolean = false;
    public isLoading: boolean = false;

    @Watch("profileRegistration.region") onRegionChanged(value: any, oldValue: any) {
        if (!value) {
            this.provinces = [];
            this.profileRegistration.province = null;
        } else if (value !== oldValue) {
            this.getProvinces(value);
        }
    }

    @Watch("profileRegistration.province") onProvinceChanged(value: any, oldValue: any) {
        if (!value) {
            this.profileRegistration.province = null;
            this.profileRegistration.postCode = null;
        }
    }

    @Watch("locationSearchText")
    public async onSearchTextChange(newText: any, oldText: any) {
        if (newText != null && newText.length >= 3) {
            await this.getLocations();
        } else if (newText === null || newText.length === 0) {
            this.clear();
        }
    }

    public created() {
        this.getTaxCountries();
        this.getCountries();
        this.getRegions();
        this.getAddressTypes();
        this.getPrivacyPolicy();

        const outsideClickListener = event => {
            if (!this.$el.contains(event.target)) {
                this.clear();
            }
        }

        document.addEventListener("click", outsideClickListener);
    }

    public async submitProductRegistration() {
        this.validationErrors = [];

        try {
            let response = await this.$store.dispatch("yesMarineStore/productRegistrationSubmit", {
                serialNumber: this.productRegistration.serialNumber,
                powerDeclarationNumber: this.productRegistration.powerDeclarationNumber
            });

            if (response && response.status === 200) {
                if (response.data.state) {
                    for (let errorField of response.data.state) {
                        for (let message of errorField.errors) {
                            this.validationErrors.push({ message: message });
                        }
                    }
                } else {
                    this.profileInfo = response.data.profileInfo;
                    this.isProductRegistrationValidated = true;

                    this.profileRegistration = this.profileInfo.profile;
                    this.profileRegistration.confirmEmail = this.profileInfo.profile.email;
                    this.profileRegistration.isProfiling = false;
                    this.profileRegistration.isMarketing = false;
                    this.profileRegistration.marketingChannels = [];

                    this.isRegistrationFormShown = true;
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = LegacyFormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public async getTaxCountries() {
        let response = await this.$store.dispatch("yesMarineStore/getTaxCountries");
        if (response) {
            this.taxCountries = response.data.countries;
        }
    }

    public async getTaxCode() {
        this.validationErrors = [];

        try {
            let response = await this.$store.dispatch("yesMarineStore/getTaxCode", {
                name: this.profileRegistration.name,
                surname: this.profileRegistration.surname,
                birthDate: this.profileRegistration.birthDate,
                birthCountry: this.profileRegistration.birthCountry,
                birthLocation: this.profileRegistration.birthLocation,
                gender: this.profileRegistration.gender
            });

            if (response && response.status === 200) {
                if (response.data.state) {
                    for (let errorField of response.data.state) {
                        for (let message of errorField.errors) {
                            this.validationErrors.push({ message: message });
                        }
                    }
                } else {
                    this.profileRegistration.taxCode = response.data.taxCode;
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = LegacyFormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public async getCountries() {
        let response = await this.$store.dispatch("profileStore/getCountries");
        if (response) {
            this.countries = response.data;
        }
    }

    public async getRegions() {
        let response = await this.$store.dispatch("profileStore/getRegions");
        if (response) {
            this.regions = response.data;
        }
    }

    public async getProvinces(region: string) {
        let response = await this.$store.dispatch("profileStore/getProvinces", { region: region });
        if (response) {
            this.provinces = response.data;
        }
    }

    public async getAddressTypes() {
        let response = await this.$store.dispatch("yesMarineStore/getAddressTypes");
        if (response) {
            this.addressTypes = response.data.addressTypes;
        }
    }

    public async getPrivacyPolicy() {
        let response = (await this.$store.dispatch("yesMarineStore/getPrivacyPolicy")).data;
        if (response) {
            this.privacyPolicy = response.privacyPolicy.text;
        }
    }

    public showPrivacyPolicy() {
        this.isPrivacyPolicyShown = !this.isPrivacyPolicyShown;
    }

    public profiling(profiling: boolean) {
        this.profileRegistration.isProfiling = profiling;
    }

    public marketing(marketing: boolean) {
        this.profileRegistration.isMarketing = marketing;
    }

    public marketingChannels(marketingChannels: any) {
        this.profileRegistration.marketingChannels = marketingChannels;
    }

    public async submitProfileRegistration() {
        if (!this.isLoading) {
            this.isLoading = true;
            this.validationErrors = [];

            try {
                let response = await this.$store.dispatch("yesMarineStore/profileRegistrationSubmit", {
                    idMaster: this.profileRegistration.idMaster,
                    productSerialNumber: this.profileRegistration.productSerialNumber,
                    productPowerDeclarationNumber: this.profileRegistration.productPowerDeclarationNumber,
                    typeProfile: this.profileRegistration.typeProfile,
                    company: this.profileRegistration.company,
                    vat: this.profileRegistration.vat,
                    name: this.profileRegistration.name,
                    secondName: this.profileRegistration.secondName,
                    surname: this.profileRegistration.surname,
                    birthDate: this.profileRegistration.birthDate,
                    birthCountry: this.profileRegistration.birthCountry,
                    birthLocation: this.profileRegistration.birthLocation,
                    gender: this.profileRegistration.gender,
                    taxCode: this.profileRegistration.taxCode,
                    country: this.profileRegistration.country,
                    region: this.profileRegistration.region,
                    province: this.profileRegistration.province,
                    location: this.profileRegistration.location,
                    postCode: this.profileRegistration.postCode,
                    addressType: this.profileRegistration.addressType,
                    address: this.profileRegistration.address,
                    addressNumber: this.profileRegistration.addressNumber,
                    email: this.profileRegistration.email,
                    confirmEmail: this.profileRegistration.confirmEmail,
                    mobile: this.profileRegistration.mobile,
                    phone: this.profileRegistration.phone,
                    isProfiling: this.profileRegistration.isProfiling,
                    isMarketing: this.profileRegistration.isMarketing,
                    marketingChannels: this.profileRegistration.marketingChannels
                });

                if (response && response.status === 200) {
                    this.isSuccess = true;
                    this.isRegistrationFormShown = false;
                }

            } catch (error) {
                this.isSuccess = false;
                if (error.response && error.response.status === 400) {
                    this.validationErrors = LegacyFormHelper.getValidationErrors(error.response.data);
                }
            }

            this.isLoading = false;
        }
    }

    public async getLocations() {
        let response: any = null;

        response = await this.$store.dispatch("profileStore/getLocations", {
            prefix: this.locationSearchText,
            provinceCode: this.profileRegistration.province,
        });

        if (response.data) {
            this.locations = response.data;
        }
    }

    public setLocation(location: any) {
        this.profileRegistration.location = location.location;
        this.profileRegistration.postCode = location.postCode;
    }

    public changeLocation() {
        this.profileRegistration.location = null;
        this.profileRegistration.postCode = null;
    }

    public clear() {
        this.locations = [];
        this.locationSearchText = null;
    }
}